import { render, staticRenderFns } from "./scheduleAuto.vue?vue&type=template&id=01a3f67a"
import script from "./scheduleAuto.vue?vue&type=script&lang=js"
export * from "./scheduleAuto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports